import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-email-preview',
  templateUrl: './email-preview.component.html',
  styleUrls: ['./email-preview.component.scss']
})
export class EmailPreviewComponent implements OnInit {
	// Rendered through a sandboxed iframe with no allow-scripts / allow-same-origin / allow-forms, so
	// the email HTML cannot run scripts, submit forms, or reach this origin. bypassSecurityTrustHtml is
	// safe here only because of that sandbox; do not move this value into [innerHTML].
	// The sandbox does let a recipient's click follow a link: target="_blank" links open a normal,
	// unsandboxed tab (allow-popups + allow-popups-to-escape-sandbox), and links without a target go to
	// the whole page via <base target="_top"> (allow-top-navigation-by-user-activation). With sandbox=""
	// every link click was silently blocked, which broke the SMS "view this email" page.
	public emailHtml: SafeHtml;
	public loading: boolean = true;
	public error: boolean = false;
	private campaignID: string;
	private employerID: string;

	constructor(
		private route: ActivatedRoute,
		private dataService: DataService,
		private sanitizer: DomSanitizer
	) {}

	ngOnInit(): void {
		this.campaignID = this.route.snapshot.paramMap.get("campaignID");
		this.employerID = this.route.snapshot.paramMap.get("employerID");

		if (this.campaignID && this.employerID) {
			this.loadEmailHtml();
		} else {
			this.error = true;
			this.loading = false;
		}
	}

	/** Adds <base target="_top"> inside <head> (or <html>) so untargeted links leave the frame. Keeps an existing <base>. */
	private static withTopBase(html: string): string {
		if (!html || /<base\b/i.test(html)) return html;
		const base = '<base target="_top">';
		for (const tag of [/<head\b[^>]*>/i, /<html\b[^>]*>/i]) {
			const m = tag.exec(html);
			if (m) return html.slice(0, m.index + m[0].length) + base + html.slice(m.index + m[0].length);
		}
		return base + html;
	}

	private loadEmailHtml(): void {
		this.dataService.getEmailHtml(this.campaignID, this.employerID).subscribe({
			next: (html) => {
				this.emailHtml = this.sanitizer.bypassSecurityTrustHtml(EmailPreviewComponent.withTopBase(html));
				this.loading = false;
			},
			error: (err) => {
				console.error('Error loading email HTML:', err);
				this.error = true;
				this.loading = false;
			}
		});
	}
}
